import { createFileRoute } from '@tanstack/react-router'
import { IncomingWebhooks } from '@/components/webhooks/IncomingWebhooks'

export const Route = createFileRoute('/_app/settings/webhooks/incoming')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="space-y-6 pt-6">
      <IncomingWebhooks />
    </div>
  )
}
